module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newList),
      expression: "newList"
    }],
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleSlidesOnly",
      "data-ride": "carousel",
      "data-interval": "2000"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.newList), function(item, index) {
    return _c('li', {
      key: index + "100",
      class: index == 0 ? 'active' : '',
      attrs: {
        "data-target": "#carouselExampleSlidesOnly",
        "data-slide-to": index
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.newList), function(item, index) {
    return _c('div', {
      key: index,
      class: index == 0 ? 'carousel-item active' : 'carousel-item'
    }, [_c('img', {
      staticClass: "d-block w-100",
      attrs: {
        "src": item.url,
        "alt": item.alt
      },
      on: {
        "click": function($event) {
          return _vm.imgClick(item.thirdUrl)
        }
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d0ba4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/module/carousel.vue
// module id = 95
// module chunks = 1